const s = {
  name: "RfidCard",
  dimensions: { width: 40, height: 32 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 32" style="enable-background:new 0 0 40 32;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M27,2c6.1,0,11,4.9,11,11h2c0-7.2-5.8-13-13-13V2z"/>
		<path class="st0" d="M33,13c0-3.3-2.7-6-6-6V5c4.4,0,8,3.6,8,8H33z"/>
		<path class="st0" d="M0,13c0-1.7,1.3-3,3-3h24c1.7,0,3,1.3,3,3v16c0,1.7-1.3,3-3,3H3c-1.7,0-3-1.3-3-3V13z M3,12c-0.6,0-1,0.4-1,1
			v16c0,0.6,0.4,1,1,1h24c0.6,0,1-0.4,1-1V13c0-0.6-0.4-1-1-1H3z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as RfidCard
};
